import { createSelector } from 'reselect'
import { RootState } from '../../model/model'
import { VAScale } from '../../model/vaScales'

export const getVaScales = (state: RootState) => state.vaScales.scales

const normalizeScaleValue = (value: string) =>
	typeof value === 'string' && value.includes(',')
		? value.replace(',', '.')
		: value

export const selectVaScaleCatalog = (scale: VAScale) =>
	createSelector([getVaScales], scales => {
		return [
			...new Set(
				scales
					.map(s => s[scale])
					.filter(s => s !== undefined || s !== null)
					.map(val => normalizeScaleValue(val as string))
					.sort((a: string, b: string) => {
						const _a = Number(a)
						const _b = Number(b)

						if (isNaN(_a) && isNaN(_b)) return _a - _b
						else if (isNaN(_a) && !isNaN(_b)) return 1
						else if (!isNaN(_a) && isNaN(_b)) return -1
						else return _a - _b
					}) || [],
			),
		]
	})
export const selectVaScaleByValue = (
	currentScale: VAScale,
	currentValue: string,
) =>
	createSelector([getVaScales], scales => {
		const vaScaleRecord = scales.find(s => {
			const normalizedValue = normalizeScaleValue(s[currentScale])
			return currentValue === normalizedValue ? s : null
		})
		if (!vaScaleRecord) {
			console.error(
				`No VA scale record found for value: ${currentValue} in scale: ${currentScale}`,
			)
			return null
		}
		const normalizedVaScaleRecord = {
			...vaScaleRecord,
			decimal: normalizeScaleValue(vaScaleRecord.decimal),
			meter6: normalizeScaleValue(vaScaleRecord.meter6),
			feet20: normalizeScaleValue(vaScaleRecord.feet20),
		}
		return normalizedVaScaleRecord
	})

export const selectVaScaleCatalogAsOptions = (scale: VAScale) =>
	createSelector([selectVaScaleCatalog(scale)], opts =>
		opts.map(e => ({ label: e, value: e })),
	)
